module.exports = __webpack_public_path__ + "img/product_yj.7938ddf0.png";